import { $api } from '@shared/api';
import { getIdFromUrlPath } from '@shared/helpers';
import {
    ActiveDrag,
    IRequestedDataToMove,
    TOrderItem,
} from '@widgets/OrdersRecognition/model/types';

const getRouteOrThrow = (routeName: string) => {
    // @ts-ignore
    const route = routable?.getRoute?.(routeName);
    if (!route) {
        throw new Error(`[OrdersRecognition] Route "${routeName}" is not available`);
    }
    return route;
};

export const ordersRecognitionUploadFunc = <T>(data: T) =>
    $api.post(getRouteOrThrow('ordersRecognitionUpload'), data);
export const ordersRecognitionListFunc = ({ signal }: { signal: AbortSignal }) => {
    const estimateId = getIdFromUrlPath('estimate');
    const ordersRecognitionListUrl = getRouteOrThrow('getOrdersRecognitionList');
    const formattedUrl = estimateId
        ? `${ordersRecognitionListUrl}?estimate_id=${estimateId}`
        : ordersRecognitionListUrl;

    return $api(formattedUrl, { signal });
};
export const ordersRecognitionDeleteFunc = (orderId: TOrderItem['id']) => {
    const ordersRecognitionDeleteUrl = getRouteOrThrow('ordersRecognitionDelete');
    const formattedUrl = ordersRecognitionDeleteUrl.replace('_purchaseDocumentId_', orderId);
    return $api.post(formattedUrl);
};
export const ordersRecognitionSearchFunc = (
    { signal }: { signal: AbortSignal },
    queryString: string
) => {
    const estimateId = getIdFromUrlPath('estimate');
    const ordersRecognitionSearchUrl = getRouteOrThrow('ordersRecognitionSearch');
    const formattedUrl =
        estimateId && queryString
            ? `${ordersRecognitionSearchUrl}?estimate_id=${estimateId}&query_string=${queryString}`
            : `${ordersRecognitionSearchUrl}?query_string=${queryString}`;

    return $api(formattedUrl, { signal });
};
export const createExcessFunc = ({
    estimateId,
    data,
}: {
    estimateId: string;
    data: IRequestedDataToMove;
}) => {
    const createExcessUrl = getRouteOrThrow('createExcessUrl');
    const formattedUrl = createExcessUrl.replace('_estimateId_', estimateId);
    const { name, amount, price, supplier, unit } = data;
    const formData = new FormData();

    formData.append('amount', String(amount));
    formData.append('name', name);
    formData.append('price', String(price));
    formData.append('supplier', supplier);
    formData.append('status', '6');
    // formData.append('payment_status', '4');
    if (unit) {
        formData.append('unit', unit);
    }
    return $api.post(formattedUrl, formData);
};
export const createBudgetItemFunc = ({
    positionCheckGuid,
    positionGuid,
    data,
}: {
    positionCheckGuid: string;
    positionGuid: string;
    data: IRequestedDataToMove;
}) => {
    const { name, amount, price, supplier, unit } = data;
    const formData = new FormData();

    formData.append('amount', String(amount));
    formData.append('name', name);
    formData.append('price', String(price));
    formData.append('supplier', supplier);
    formData.append('status', '6');
    // formData.append('payment_status', '4');
    if (unit) {
        formData.append('unit', unit);
    }

    const createBudgetItemUrl = getRouteOrThrow('createCheckUrl');
    const formattedUrl = createBudgetItemUrl.replace('_guid_', positionGuid);
    return $api.post(formattedUrl, formData);
};

export const updateBudgetItemFunc = ({
    positionCheckGuid,
    data,
}: {
    positionCheckGuid: string;
    data: IRequestedDataToMove;
}) => {
    const { name, amount, price, unit } = data;
    const updateBudgetItemUrl = getRouteOrThrow('updateCheckUrl');
    const formattedUrl = updateBudgetItemUrl.replace('_guid_', positionCheckGuid);
    const formData = new FormData();

    formData.append('name', name);
    formData.append('amount', String(amount));
    formData.append('price', String(price));
    if (unit) {
        formData.append('unit', unit);
    }

    return $api.post(formattedUrl, formData);
};
export const updateItemSupplierFunc = (
    itemGuid: string,
    supplier: IRequestedDataToMove['supplier']
) => {
    const updateItemSupplierUrl = getRouteOrThrow('updateSupplierCheckUrl');
    const formattedUrl = updateItemSupplierUrl.replace('_guid_', itemGuid);
    const formData = new FormData();
    formData.append('supplier', supplier);
    return $api.post(formattedUrl, formData);
};
export const saveOrderCommentFunc = (itemGuid: string, displayString: string) => {
    const saveOrderCommentUrl = getRouteOrThrow('saveOrderCommentUrl');
    const formattedUrl = saveOrderCommentUrl.replace('_guid_', itemGuid);
    const formData = new FormData();
    formData.append('text', displayString);
    return $api.post(formattedUrl, formData);
};
export const saveExcessItemCommentFunc = (itemGuid: string, displayString: string) => {
    const saveExcessCommentUrl = getRouteOrThrow('saveExcessCommentUrl');
    const formattedUrl = saveExcessCommentUrl.replace('_excessId_', itemGuid);
    const formData = new FormData();
    formData.append('text', displayString);
    return $api.post(formattedUrl, formData);
};
export const setItemProceedFunc = (itemType: ActiveDrag['type'], itemGuid: string) => {
    const setItemProceedUrl = getRouteOrThrow('ordersRecognitionSetItemProceed');
    const formData = new FormData();
    formData.append(
        itemType === 'order' ? 'purchase_document_id' : 'purchase_document_position_id',
        itemGuid
    );
    return $api.post(setItemProceedUrl, formData);
};
export const updateCheckStatusDateFunc = (documentDate: string, itemGuid: string) => {
    const updateCheckStatusDateUrl = getRouteOrThrow('updateCheckStatusDate');
    const formattedUrl = updateCheckStatusDateUrl.replace('_guid_', itemGuid);
    const formData = new FormData();
    formData.append('status', '6');
    formData.append('date', documentDate);

    return $api.post(formattedUrl, formData);
};
export const updateExcessCheckStatusDateFunc = (documentDate: string, itemGuid: string) => {
    const updateExcessCheckStatusDateUrl = getRouteOrThrow('updateExcessStatusDate');
    const formattedUrl = updateExcessCheckStatusDateUrl.replace('_guid_', itemGuid);
    const formData = new FormData();
    formData.append('status', '6');
    formData.append('date', documentDate);

    return $api.post(formattedUrl, formData);
};
// export const moveBudgetItemFunc = ({ signal }: { signal: AbortSignal }, itemGuid: string) => {
//     console.log('moveBudgetItemFunc itemGuid', itemGuid);
//     const formattedUrl = moveBudgetItemUrl.replace('_guid_', itemGuid);
//     return $api.post(formattedUrl, { signal });
// };
